const QRCODE_CONTENT_MAX_LENGTH = 100;

function buildTaskImageAuditListParams(filters, page, pageSize) {
  const params = {
    page,
    page_size: pageSize,
    task_id: filters.task_id,
    unionid: filters.unionid,
  };
  if (filters.violation === "pending") params.is_violation = null;
  if (filters.violation === "true") params.is_violation = true;
  if (filters.violation === "false") params.is_violation = false;
  if (filters.onlyHasQrcode) params.has_qrcode = true;
  return params;
}

function getQrcodeContents(record) {
  if (Array.isArray(record.qrcode_contents) && record.qrcode_contents.length) {
    return record.qrcode_contents;
  }
  return record.qrcode_content ? [record.qrcode_content] : [];
}

function truncateQrcodeContent(content, expanded) {
  const value = String(content || "");
  if (expanded || value.length <= QRCODE_CONTENT_MAX_LENGTH) {
    return value;
  }
  return value.slice(0, QRCODE_CONTENT_MAX_LENGTH) + "...";
}

function needsQrcodeExpansion(content) {
  return String(content || "").length > QRCODE_CONTENT_MAX_LENGTH;
}

function isPass(record) {
  return record.is_violation === false;
}

function isViolation(record) {
  return record.is_violation === true;
}

module.exports = {
  buildTaskImageAuditListParams,
  getQrcodeContents,
  isPass,
  isViolation,
  needsQrcodeExpansion,
  truncateQrcodeContent,
};
